import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

// pipes
import { InitialsPipe } from './pipes/initials.pipe';
import { CategoryNamePipe } from './pipes/category-name.pipe';
import { PhoneMaskPipe } from './pipes/phone-mask.pipe';

// components
import { EnumerationFilterComponent } from './components/enumeration-filter/enumeration-filter.component';
import { SortOrderComponent } from './components/sort-order/sort-order.component';
import { InitialsCircleComponent } from './components/initials-circle/initials-circle.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { CourtEventStatusPillComponent } from './components/court-event-status-pill/court-event-status-pill.component';
import { PlayerRulesMessageComponent } from './components/player-rules-message/player-rules-message.component';
import { PlayerStatusPipe } from './pipes/player-status.pipe';
import { MemberStatusBadgeComponent } from './components/member-status-badge/member-status-badge.component';


@NgModule({
    declarations: [
        InitialsPipe,
        EnumerationFilterComponent,
        SortOrderComponent,
        InitialsCircleComponent,
        TimePickerComponent,
        CategoryNamePipe,
        CourtEventStatusPillComponent,
        PlayerRulesMessageComponent,
        PhoneMaskPipe,
        PlayerStatusPipe,
        MemberStatusBadgeComponent
    ],
    exports: [
        InitialsPipe,
        EnumerationFilterComponent,
        SortOrderComponent,
        InitialsCircleComponent,
        TimePickerComponent,
        CategoryNamePipe,
        CourtEventStatusPillComponent,
        PlayerRulesMessageComponent,
        PhoneMaskPipe,
        PlayerStatusPipe,
        MemberStatusBadgeComponent
    ],
    imports: [CommonModule, TranslateModule, NgxMaskDirective],
    providers: [NgxMaskPipe]
})
export class SharedModule {}

export * from './services/validation.service';
